import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../../_services';
import { Roles } from '../../_models';
import { Constants } from '../Constants';
import { Observable } from 'rxjs';

export const authGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | Observable<boolean> | Promise<boolean> => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const roles: Roles[] = auth.getCurrentUserRoles();
  const routeObj = Constants.getRoute(route.routeConfig?.path!);
  let canActivate = false;

  if (auth.isExpiredToken) {
    console.warn('Auth token is expired');
    return auth.ShowDialog();
  }

  if (!auth.isLoggedIn) {
    auth.SignOut();
    return false;
  }

  if (routeObj) {
    canActivate = roles ? Constants.canAccess(roles, routeObj[1]) : false;
  }

  if (!canActivate) {
    router.navigate([Constants.Routing.NOT_ALLOWED.path]);
  }

  return canActivate;
};
